import { render, staticRenderFns } from "./EmployeeProfile.vue?vue&type=template&id=1e4de2b0"
import script from "../../controllers/employee/employee-profile.js?vue&type=script&lang=js&external"
export * from "../../controllers/employee/employee-profile.js?vue&type=script&lang=js&external"
import style0 from "./EmployeeProfile.vue?vue&type=style&index=0&id=1e4de2b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports